<template>
  <v-container fluid grid-list-sm>
    <v-row>
      <v-col cols="12" sm="9">
        <h3 class="display-1 primary--text">Scripts</h3>
      </v-col>
      <v-col cols="12" sm="3">
        <v-btn @click="createScript" x-large class="float-right" color="primary" fab icon>
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="12">
        <v-data-table :loading="isLoading" :headers="headers" :items="scripts" class="elevation-1 mt-5">
          <template v-slot:item.actions="{item}">
            <v-icon color="info" class="mr-2" @click="editScript(item)">mdi-pencil</v-icon>
            <v-icon color="error" class="mr-2" @click="deleteScript(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "Scripts",
  computed: {
    ...mapState("scripts", ["scripts"]),
  },
  async mounted() {
    await this.setScripts();
  },
  data() {
    return {
      isLoading: false,
      headers: [
        {text: 'Name', value: 'name'},
        {text: 'Details', value: 'details'},
        {text: 'Actions', value: 'actions', sortable: false}
      ]
    }
  },
  methods: {
    ...mapActions("scripts", ["setScripts", "setActiveScript", "setManageScriptDialog", "setManageDeleteScriptDialog"]),
    ...mapMutations("app", ["setToast"]),
    async createScript() {
      await this.setActiveScript({});
      await this.setManageScriptDialog(true);
    },
    async editScript(item) {
      await this.setActiveScript(item);
      await this.setManageScriptDialog(true);
    },
    async deleteScript(item) {
      await this.setActiveScript(item);
      await this.setManageDeleteScriptDialog(true);
    }
  }
}
</script>

<style scoped>

</style>
